import AboutChatBotPng from "../../../../pngs/AboutChatBotPng.png";
import CmdAboutChatbot from "./CmdAboutChatbot";
import HighlightAboutChatbot from "./HighlightAboutChatbot";
import TitleAboutChatbot from "./TitleAboutChatbot";

const RightSide = () => {
  return (
    <div className="w-[60%] h-full pl-16 pt-10 pr-32 text-text5 border-l border-[#333333] pb-10">
      <div className="flex flex-col gap-8">
        <img src={AboutChatBotPng} alt="" />
        <TitleAboutChatbot title="Features" />
        <div className="space-y-1">
          <h4>
            <span className="text-[20px] text-[#666666] mx-2">–</span>
            <HighlightAboutChatbot text="Next.js" /> App Router
          </h4>
          <h4>
            <span className="text-[20px] text-[#666666] mx-2">–</span>
            React Server Components (RSCs), Suspense, and Server Actions
          </h4>
          <h4>
            <span className="text-[20px] text-[#666666] mx-2">–</span>
            <HighlightAboutChatbot text="Vercel AI SDK" />
            for streaming chat UI
          </h4>
          <h4>
            <span className="text-[20px] text-[#666666] mx-2">–</span>
            Support for OpenAI (default), Anthropic, Cohere, Hugging Face, or
            custom AI chat models
          </h4>
        </div>
        <div className="space-y-1">
          <h4>
            <span className="text-[20px] text-[#666666] mx-2">–</span>
            <HighlightAboutChatbot text="shadcn/ui" />
          </h4>
          <div className="space-y-1 ml-5">
            <h4>
              <span className="text-[20px] text-[#666666] mx-2">–</span>
              Styling with
              <HighlightAboutChatbot text="Tailwind CSS" />
            </h4>
            <h4>
              <span className="text-[20px] text-[#666666] mx-2">–</span>
              <HighlightAboutChatbot text="Radix UI" />
              for headless component primitives
            </h4>
            <h4>
              <span className="text-[20px] text-[#666666] mx-2">–</span>
              Icons from
              <HighlightAboutChatbot text="Phosphor Icons" />
            </h4>
          </div>
          <h4>
            <span className="text-[20px] text-[#666666] mx-2">–</span>
            Chat History, rate limiting, and session storage with
            <HighlightAboutChatbot text="Vercel KV" />
          </h4>
          <h4>
            <span className="text-[20px] text-[#666666] mx-2">–</span>
            <HighlightAboutChatbot text="NextAuth.js" />
            for authentication
          </h4>
        </div>
        <TitleAboutChatbot title="Model Providers" />
        <h4>
          This template ships with OpenAI
          <CmdAboutChatbot text="gpt-3.5-turbo" />
          as the default. However, thanks to the
          <HighlightAboutChatbot text="Vercel AI SDK" /> , you can switch LLM
          providers to <HighlightAboutChatbot text="Anthropic" /> ,
          <HighlightAboutChatbot text="Cohere" /> ,
          <HighlightAboutChatbot text="Hugging Face" /> , or using
          <HighlightAboutChatbot text="LangChain" /> with just a few lines of
          code.
        </h4>
        <TitleAboutChatbot title="Deploy Your Own" />
        <h4>
          You can deploy your own version of the Next.js AI Chatbot to Vercel
          with one click:
        </h4>
        <TitleAboutChatbot title="Creating a KV Database Instance" />
        <h4>
          Follow the steps outlined in the
          <HighlightAboutChatbot text="quick start guide" />
          provided by Vercel. This guide will assist you in creating and
          configuring your KV database instance on Vercel, enabling your
          application to interact with it.
        </h4>
        <h4>
          Remember to update your environment variables ({" "}
          <CmdAboutChatbot text="KV_URL" /> ,{" "}
          <CmdAboutChatbot text="KV_REST_API_URL" /> ,{" "}
          <CmdAboutChatbot text="KV_REST_API_TOKEN" /> ,{" "}
          <CmdAboutChatbot text="KV_REST_API_READ_ONLY_TOKEN" /> ) in the{" "}
          <CmdAboutChatbot text=".env" /> file with the appropriate credentials
          provided during the KV database setup.
        </h4>
        <TitleAboutChatbot title="Running locally" />
        <h4>
          You will need to use the environment variables
          <HighlightAboutChatbot text="defined in" />
          <CmdAboutChatbot text=".env.example" />
          to run Next.js AI Chatbot. It's recommended you use
          <HighlightAboutChatbot text="Vercel Environment Variables" />
          for this, but a <CmdAboutChatbot text=".env" /> file is all that is
          necessary.
        </h4>
        <div className="border-l-4 border-text5 pl-5">
          Note: You should not commit your <CmdAboutChatbot text=".env" /> file
          or it will expose secrets that will allow others to control access to
          your various OpenAI and authentication provider accounts.
        </div>
        <div className="pl-5 space-y-8">
          <h4>
            Install Vercel CLI: <CmdAboutChatbot text="npm i -g vercel" />
          </h4>
          <h4>
            Link local instance with Vercel and GitHub accounts (creates{" "}
            <CmdAboutChatbot text=".vercel" /> directory):{" "}
            <CmdAboutChatbot text="vercel link" />
          </h4>
          <h4>
            Download your environment variables:{" "}
            <CmdAboutChatbot text="vercel env pull" />
          </h4>
        </div>
        <div className="bg-[#0A0A0A] border border-[#2E2E2E] rounded-md h-32 text-subColor5 flex flex-col pt-5 pl-16">
          <span>pnpm install</span>
          <span>pnpm dev</span>
        </div>
        <h4>
          Your app template should now be running on{" "}
          <HighlightAboutChatbot text="localhost:3000" /> .
        </h4>
        <TitleAboutChatbot title="Authors" />
        <h4>
          This library is created by <HighlightAboutChatbot text="Vercel" /> and{" "}
          <HighlightAboutChatbot text="Next.js" />
          team members, with contributions from:
        </h4>{" "}
        <div className="space-y-1">
          <h4>
            <span className="text-[20px] text-[#666666] mx-2">–</span>
            Jared Palmer (
            <HighlightAboutChatbot text="@jaredpalmer" /> ) - <HighlightAboutChatbot text="Vercel" />
          </h4>
          <h4>
            <span className="text-[20px] text-[#666666] mx-2">–</span>
            Shu Ding (
            <HighlightAboutChatbot text="@shuding_" /> ) - <HighlightAboutChatbot text="Vercel" />
          </h4>
          <h4>
            <span className="text-[20px] text-[#666666] mx-2">–</span>
            shadcn (
            <HighlightAboutChatbot text="@shadcn" /> ) - <HighlightAboutChatbot text="Vercel" />
          </h4>
        </div>
      </div>
    </div>
  );
};

export default RightSide;
